export type FacebookLoginResult = {
    accessToken?: string | null;
    isCancelled?: boolean;
};

export async function loginWithFacebook(): Promise<FacebookLoginResult> {
    return await new Promise((resolve, reject) => {
        const fb = (window as any).FB;

        if (!fb?.login) {
            reject(new Error('Facebook SDK is not available on web.'));
            return;
        }

        fb.login(
            (response: any) => {
                if (response?.status === 'connected') {
                    resolve({
                        accessToken: response.authResponse?.accessToken || null,
                        isCancelled: false,
                    });
                    return;
                }

                resolve({ accessToken: null, isCancelled: true });
            },
            { scope: 'public_profile,email' }
        );
    });
}
